import React from 'react'
import PropTypes from 'prop-types'
import classes from 'classnames'

const ButtonGroup = ({ children, isOpen, className }) => (
    <div className={ classes('btn-group', className, { open: isOpen }) }>
        { children }
    </div>
)

ButtonGroup.propTypes = {
    isOpen: PropTypes.bool
}

export default ButtonGroup
